"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackData = exports.trackGQLData = void 0;
const tslib_1 = require("tslib");
const contentful_tracking_1 = tslib_1.__importDefault(require("@telus/contentful-tracking"));
const isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
// track GQL data
const trackGQLData = async (data, applicationName, spaceId) => {
    if (!applicationName) {
        throw new Error('Contentful tracking application name cannot be blank.');
    }
    if (!(0, isEmpty_1.default)(data)) {
        const tracker = new contentful_tracking_1.default(spaceId, applicationName);
        await tracker.GQLTracker(data);
    }
};
exports.trackGQLData = trackGQLData;
// track Rest API data
const trackData = async (data, applicationName, spaceId) => {
    if (!applicationName) {
        throw new Error('Contentful tracking application name cannot be blank.');
    }
    if (!(0, isEmpty_1.default)(data)) {
        const tracker = new contentful_tracking_1.default(spaceId, applicationName);
        await tracker.tracker(data);
    }
};
exports.trackData = trackData;
//# sourceMappingURL=tracker.js.map